import Row from "@Containers/components/Row";
import IconArrowAirplane from "@Icons/arrows/IconArrowAirplane";

interface DirectionAmenitiesPillProps {
    title: string,
    departureStationName: string,
    destinationStationName: string,
}

function DirectionAmenitiesPill(props: DirectionAmenitiesPillProps) {
    const {
        title,
        departureStationName,
        destinationStationName,
    } = props

    return (
        <>
            <span className="amenities-direction-pill__title">
                {title}
            </span>
            <Row center gap className="amenities-direction-pill__description">
                {departureStationName}
                <IconArrowAirplane
                    width="12"
                    height="12"
                />
                {destinationStationName}
            </Row>
        </>
    )
}

export default DirectionAmenitiesPill